export default "__VITE_ASSET__BMCnUsMW__"